import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { MarkPalletCompleteFormDataKey } from "src/types";

export class MarkPalletCompleteFormValidator extends FormValidator {
  private static validateRequiredDimension(
    value: unknown,
    fieldName: MarkPalletCompleteFormDataKey,
    label: string
  ): ValidationError<MarkPalletCompleteFormDataKey> | undefined {
    if (value === undefined || value === null || value === "") {
      return new ValidationError(`${label} is required`, fieldName);
    }
    const num = Number(value);
    if (isNaN(num) || num <= 0) {
      return new ValidationError(`${label} must be a positive number`, fieldName);
    }
    return undefined;
  }

  private static readonly validationStrategies: Record<
    MarkPalletCompleteFormDataKey,
    (value: unknown) => ValidationError<MarkPalletCompleteFormDataKey> | undefined
  > = {
    weight: (value) => MarkPalletCompleteFormValidator.validateRequiredDimension(value, "weight", "Weight"),
    length: (value) => MarkPalletCompleteFormValidator.validateRequiredDimension(value, "length", "Length"),
    width: (value) => MarkPalletCompleteFormValidator.validateRequiredDimension(value, "width", "Width"),
    height: (value) => MarkPalletCompleteFormValidator.validateRequiredDimension(value, "height", "Height")
  };

  static validateMarkPalletCompleteFormData<T extends MarkPalletCompleteFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(formData, MarkPalletCompleteFormValidator.validationStrategies as never);
  }
}
